module.exports = __webpack_public_path__ + "img/poster-fantazy.4bf1bc53.png";